import React, { useEffect, useRef, useState } from "react";
import "../css/layout.css";
import css from "../css/Profile.module.css";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import Rightcontainer from "../Components/Rightcontainer";
import Swal from "sweetalert2";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "../css/kyc.css";
import "../css/Loader.css";
import findGif from "../css/loading_old.gif";
import { useContext } from "react";
import { LanguageContext } from "../Components/LanguageContext";
import { useTheme } from "../../ThemeContext";
import { BsPerson } from "react-icons/bs";
import { apiRequest } from "../../apiService/allApi";
import { LuIndianRupee } from "react-icons/lu";

const Profile1 = ({ profile }) => {
  // language
  const translations = {
    hi: {
      wallet: "वॉलेट",
      refer: "किसी  मित्र का रेफर कोड इस्तेमाल करे | ",
      win: "पैसा जिता | ",
      game: "गेम खेला | ",
      referEarn: "रेफरल कमाई  ",
      referPerson: "आमंत्रित किये दोस्त | ",
    },
    en: {
      wallet: "My Wallet",
      refer: "Use Refer Code",
      Win: "Coin Won",
      game: "Battle Played",
      referEarn: "Referral Earning",
      referPerson: "Referred Players",
    },
  };

  const { language } = useContext(LanguageContext);

  // BASE URL

  // const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  // const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  // const nodeMode = process.env.NODE_ENV;
  // if (nodeMode === "development") {

  //   var baseUrl = beckendLocalApiUrl;
  // } else {
  //   baseUrl = beckendLiveApiUrl;
  // }

  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  // alert(baseUrl)
  // +++++++++++++++++++++++++++++
  const [show, setShow] = useState(false);

  const [show1, setShow1] = useState(false);

  const handleClose = () => setShow1(false);
  const handleShow = () => {
    setShow1(true);
  };

  const [referral, setCode] = useState("");
  const [Id, setId] = useState(null);
  const [msg, setMsg] = useState("");

  // const [profile, setProfile] = useState();
  const [portcss, setPortcss] = useState(css.active_tab);
  const [portcss1, setPortcss1] = useState(css.inactive_tab);
  const [crushcss, setCrushcss] = useState(true);
  const [holder_name, setHolder_name] = useState();
  const [account_number, setAccount_number] = useState();
  const [ifsc_code, setIfsc_code] = useState();
  const [upi_id, setUpi_id] = useState();
  const [isLoading, setIsloading] = useState(false);

  // KYC MODEL

  const [showKyc, setShowKyc] = useState(false);
  const [showBottom, setShowBottom] = useState(false);
  const [process1, setProcesss] = useState(false);

  const udata = localStorage.getItem("udata");
  const profileData = JSON.parse(udata);
  const siteData = localStorage.getItem("sitSetting");
  const SData = JSON.parse(siteData);

  const handleCloseBottom = () => setShowBottom(false);
  const handleShowBottom = (data) => {
    setShowBottom(true);
  };
  const handleCloseKyc = () => {
    setShowKyc(false);
  };
  const handleShowKyc = () => setShowKyc(true);
  const [inputOpen, setInputOpen] = useState(false);
  const [Email, setEmail] = useState();

  const toggleInput = () => {
    setInputOpen(!inputOpen);
  };

  const history = useHistory();



 const logout = async () => {
    localStorage.clear()
    let access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    const res = await apiRequest(`me`, "GET", null, headers)
      .then((res) => {
        if (res.data) {
        }
      })
      .catch((e) => {
        if (e.response.status == 401) {
          localStorage.removeItem("token");
          localStorage.removeItem("token");
          window.location.reload();
          history.push("/login");
        }
      });
  };


  //Update email

  const UpdateEmail = async () => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    if (Email != null) {
      try {
        const respone = await apiRequest(
          `user/profile/edit`,
          "PATCH",
          { Email },
          headers,
        );
        if (respone.data.status == false) {
          Swal.fire({
            title: respone.data.msg,
            icon: "error",
            confirmButtonText: "OK",
          });
        } else {
          setEmail(respone?.data?.user?.Email);
          setInputOpen(false);
          Swal.fire({
            title: respone.data.msg,
            icon: "Success",
            confirmButtonText: "OK",
          });
          // UserALL();
        }
      } catch (error) {}
    } else {
      Swal.fire({
        title: "Please enter your Email",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  // name Update
  const [Name, setName] = useState();

  const UpdateProfile = async () => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    if (Name != null) {
      const respone = await apiRequest(
        `user/profile/edit`,
        "PATCH",
        { Name },
        headers,
      );
      if (respone.data.status == false) {
        Swal.fire({
          title: respone.data.msg,
          icon: "error",
          confirmButtonText: "OK",
        });
      } else {
        setName(respone?.data?.user?.Name);
        Swal.fire({
          title: respone.data.msg,
          icon: "Success",
          confirmButtonText: "OK",
        });
        // UserALL();
      }
    } else {
      Swal.fire({
        title: "Please enter your Name",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };
  const updateBankDetails = async (e) => {
    e.preventDefault();
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    let alldata = {
      holder_name,
      account_number,
      ifsc_code,
      upi_id,
    };
    const res = await apiRequest(
      `user/profile/edit`,
      "PATCH",
      alldata,
      headers,
    );

    if (res.data.status == false) {
      setShow((prev) => !prev);
      // UserALL();
      let message;
      message = res.data.msg;
      if (!res.data.msg) {
        message = "something went wrong";
      }
      Swal.fire({
        title: message,
        icon: res.data.submit ? "success" : "error",
        confirmButtonText: "OK",
      });
    }
    // });
  };
  const update_RefCode = async () => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(
        `user/profile/edit`,
        "PATCH",
        { referral },
        headers,
      );
      console.log(res, "sss");
      if (res.data.submit == false) {
        Swal.fire({
          title: res.data.msg,
          icon: "error",
          confirmButtonText: "OK",
        });
      } else {
        Swal.fire({
          title: res.data.msg,
          icon: "success",
          confirmButtonText: "OK",
        });
      }
    } catch (e) {}
  };

  //// total game
  const [total, setTotal] = useState();
  const TotalGame = async (Id) => {
    let access_token = localStorage.getItem("token");
    let userId = localStorage.getItem("userId");

    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(
        `total/user/all/${userId}`,
        "GET",
        null,
        headers,
      );
      if (res.data) {
        setTotal(res.data);
      }
    } catch (e) {}
  };

  const [pic, setPic] = useState();
  const Result = async (file) => {
    if (file) {
      const access_token = localStorage.getItem("token");

      const headers = {
        Authorization: `Bearer ${access_token}`,
      };

      const formData = new FormData();
      formData.append("avatar", file);

      // await fetch(baseUrl+`users/me/avatar`, {
      //   method: "POST",
      //   body: formData,
      //   headers,
      // })
      const res = await apiRequest(
        `users/me/avatar`,
        "POST",
        formData,
        headers,
      );
      // .then((res) => {});
    }
  };
  //avatar

  const Kyc = async () => {
    setShowKyc(true);
    const inputOptions = new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          "Auto Kyc": "Auto Kyc",
          "Complete Kyc": "Complete Kyc",
        });
      }, 1000);
    });
  };

  // AADHAR API

  const [AadharNum, setAadharNum] = useState("");
  const [userAdharData, setUserAdharData] = useState("");
  const handleAdharChnage = (e) => {
    setAadharNum(e.target.value);
  };

  const AdharNumber = async (e) => {
    setIsloading(true);
    e.preventDefault();

    // Ensure AadharNum is a 12-digit number before making the API call
    if (/^[0-9]{12}$/.test(AadharNum)) {
      const access_token = localStorage.getItem("token");
      const headers = {
        Authorization: `Bearer ${access_token}`,
      };

      const data = {
        aadharNumber: AadharNum,
      };
      try {
        const res = await apiRequest("aadharcard-auto", "POST", data, headers);
        setUserAdharData(res?.data);
        setIsloading(false);

        if (res.data.status === false) {
          setMsg(res?.data?.msg);
        } else {
          setMsg(res?.data?.data?.message);
          // Swal.fire({
          //   icon: "success",
          //   title: "Send OTP to your mobile number",
          //   text: res?.data?.data?.data?.message,
          // });
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Invalid Aadhar Number",
        text: "Please enter a valid 12-digit Aadhar number.",
      });
      setIsloading(false);
    }
  };

  const AdharOtp = async (e) => {
    setIsloading1(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    const data = {
      aadharNumber: AadharNum,
      otp: AadharOtp,
      Email: Email,
      transaction_id: userAdharData.data?.ref_id,
    };

    try {
          const res = await apiRequest(
            `aadharcard-auto-verify`,
            "POST",
            data,
            headers,
          );
          setKycdata(res.data);
          setVerifyData(res.data);
          setIsloading1(false);
    
          if (res.data.status === false) {
            if (res.data?.msg) {
              setMsg(res.data?.msg);
            } else {
              setMsg(res.data?.message);
            }
          } else {
             setShowKyc(false);
            // handleCloseKyc();
            history.push("/Home");
            window.location.reload();
    
          }
        } catch (e) {
          console.log(e);
        }
  };

  const [AadharOtp, setAadharOtp] = useState("");
  const [verifyData, setVerifyData] = useState("");
  const [kycdata, setKycdata] = useState();
  const [isLoading1, setIsloading1] = useState(false);

  const handleAdharOtpChnage = (e) => {
    setAadharOtp(e.target.value);
  };

  // DOCUMENTATION API START

  let aadharProcess = useRef(false);

  const [Names, setNames] = useState("");
  const [DOB, setDob] = useState("");
  const [frontLoaded, setFrontLoaded] = useState(null);
  const [backLoaded, setBackLoaded] = useState(null);

  const handleSubmitdata = async (e) => {
    e.preventDefault();

    if (!Names || !DOB || !frontLoaded || !backLoaded || !AadharNum) {
      alert("Please fill in all fields and upload both images.");
      return;
    }

    if (aadharProcess.current === false) {
      setProcesss(true);
      aadharProcess.current = true;

      const formData = new FormData();
      formData.append("Name", Names);
      formData.append("DOB", DOB);
      formData.append("front", frontLoaded[0]);
      formData.append("back", backLoaded[0]);
      formData.append("Number", AadharNum);
      formData.append("Email", Email);

      const access_token = localStorage.getItem("token");
      const headers = {
        Authorization: `Bearer ${access_token}`,
      };

      // axios
      //   .post(baseUrl+`aadharcard`, formData, {
      //     headers,
      //   })
      const res = await apiRequest(`aadharcard`, "POST", formData, headers);
      // .then((res) => {
      // console.log(res.data);
      if (res.data.status === false) {
        Swal.fire({
          title: res.data.msg,
          icon: "error",
          confirmButtonText: "OK",
        }).then((result) => {
          if (result.isConfirmed) {
            handleCloseKyc();
          }
        });
      } else if (res.data.msg === "Duplicate Entity") {
        Swal.fire({
          title: "Duplicate Entity",
          icon: "error",
          confirmButtonText: "OK",
        }).then((result) => {
          if (result.isConfirmed) {
            handleCloseKyc();
          }
        });
      } else {
        Swal.fire({
          title: "Your KYC form submitted",
          icon: "success",
          confirmButtonText: "OK",
        }).then((result) => {
          if (result.isConfirmed) {
            handleCloseKyc();
          }
        });
        history.push("/Profile");
      }

      aadharProcess.current = false;
      setProcesss(false);
      // })
      // .catch((error) => {
      //   console.error(error);
      //   if (error.response && error.response.status === 401) {
      //     localStorage.removeItem("token");
      //     window.location.reload();
      //     history.push("/login");
      //   }
      // });
    } else {
      alert("You have submitted a request already.");
    }
  };

  useEffect(() => {
    // UserALL();
    TotalGame();
  }, []);

  useEffect(() => {
      const udata = JSON.parse(localStorage.getItem("udata") || "{}");
  
      if (udata?.verified === "unverified") {
        setShowKyc(true);
      }
    }, []);

  // Email validations
  const [isValidEmail, setIsValidEmail] = useState(true);

  const handleEmailChange = (e) => {
    const newEmail = e.target.value;
    setEmail(newEmail);

    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    const isValidFormat = emailRegex.test(newEmail);

    const endsWithCom = newEmail.toLowerCase().endsWith(".com");

    setIsValidEmail(isValidFormat && endsWithCom);
  };

  // change theme
  const theme = localStorage.getItem("theme");
  const styles = {
    backgroundColor: theme === "light" ? "#fff" : "black",
    color: theme === "light" ? "black" : "#fff",
  };

  return (
    <>
      {/* <Header user={profile} /> */}
      {
        <div
          className="leftContainer mb_space"
          style={{ ...styles, height: "124% !important" }}
        >
          <div className="profile_page pt-3">
            <div
              className="profile_div_main_box mx-3"
              style={{ backgroundSize: "", backgroundPosition: "center" }}
            >
              <div className="profile_div_main_inner">
                <div>
                  <label>
                    <input
                      className="d-none"
                      type="file"
                      onChange={(e) => Result(e.target.files[0])}
                      accept="image/*"
                      required
                    />
                    {profileData && profileData.avatar ? (
                      <img
                        src={
                          profileData?.avatar
                            ? `${baseUrl}/${profileData.avatar}`
                            : "/images/avatars/Avatar1.png"
                        }
                        alt=""
                        className="profie_img"
                      />
                    ) : (
                      <img
                        src="./images/avatars/Avatar3.png"
                        alt=""
                        className="profie_img"
                      />
                    )}
                  </label>
                  <div></div>
                </div>
                <div className="profile_details">
                  <h2>
                    {" "}
                    {profile && profile.Name}
                    <img
                      className={`ml-2`}
                      width="20px"
                      src="/images/icon-edit.jpg"
                      alt=""
                      onClick={() => {
                        setPortcss(css.inactive_tab);
                        setPortcss1(css.active_tab);
                      }}
                    />
                    <div className={`text-bold  ${portcss1}`}>
                      <div
                        className={`${css.MuiFormControl_root} ${css.MuiTextField_root}`}
                        style={{ verticalAlign: "bottom" }}
                      >
                        <div
                          className={`${css.MuiInputBase_root} ${css.MuiInput_root} ${css.MuiInput_underline} ${css.MuiInputBase_formControl} ${css.MuiInput_formControl}`}
                        >
                          <input
                            aria-invalid="false"
                            type="text"
                            maxLength={"20"}
                            className={`${css.MuiInputBase_input} ${css.MuiInput_input} `}
                            placeholder="Enter Username"
                            value={Name}
                            onChange={(e) => {
                              setName(e.target.value);
                            }}
                          />
                        </div>
                      </div>
                      <img
                        className="ml-2 profile_name_edit"
                        width="20px"
                        src="/images/select-blue-checkIcon.png"
                        alt=""
                        onClick={() => {
                          setPortcss(css.active_tab);
                          setPortcss1(css.inactive_tab);
                          UpdateProfile(Id);
                        }}
                      />
                    </div>
                  </h2>
                  {/* <h3> {profile && profile.Phone}</h3> */}
                </div>
              </div>
              {/* my wallet btn */}
              <div>
                {/* MODEL OF KYC  */}
                <Modal
                  show={showKyc}
                  onHide={handleCloseKyc}
                  className="Orher_page_main_section profile_page_tabs"
                  aria-labelledby="contained-modal-title-vcenter"
                  centered
                >
                  <ul
                    className="nav nav-tabs mb-4"
                    id="myTab"
                    role="tablist"
                    style={{ justifyContent: "center" }}
                  >
                    {SData.onlineKYC && (
                      <li className="nav-item mr-2" role="presentation">
                        <button
                          className="nav-link active tabs"
                          id="informative-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#informative"
                          type="button"
                          role="tab"
                          aria-controls="informative"
                          aria-selected="true"
                        >
                          Online KYC
                        </button>
                      </li>
                    )}
                    {SData.offlineKYC && (
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link "
                          id="game-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#game"
                          type="button"
                          role="tab"
                          aria-controls="game"
                          aria-selected="true"
                        >
                          Offline KYC
                        </button>
                      </li>
                    )}
                  </ul>
                  <div className="tab-content" id="myTabContent">
                    {SData.onlineKYC && (
                      <div
                        className="tab-pane fade show active"
                        id="informative"
                        role="tabpanel"
                        aria-labelledby="informative-tab"
                      >
                        <div className="input-group input-group-sm ">
                          <label className="commaon_label">
                            Enter your Aadhar Number
                          </label>
                          <input
                            type="number"
                            className="commaon_input_box border border"
                            aria-describedby="basic-addon1"
                            value={AadharNum}
                            placeholder="Aadhar Number"
                            onChange={handleAdharChnage}
                          />

                          <h5 className="mt-2" style={{ color: "red" }}>
                            {msg}
                          </h5>
                        </div>
                        <div className="input-group input-group-sm mb-3 ">
                          {isLoading ? (
                            <div
                              className="pl-2 text-center d-flex"
                              style={{
                                justifyContent: "center",
                                width: "100%",
                                marginTop: "10px",
                              }}
                            >
                              <img
                                src="/images/LandingPage_img/loader1.gif"
                                style={{
                                  width: "50px",
                                  height: "50px",
                                  margin: "auto",
                                }}
                              />
                            </div>
                          ) : userAdharData?.status != true ? (
                            <div>
                              <button
                                onClick={AdharNumber}
                                className="mt-2 btn text-white btn-dark"
                              >
                                Send OTP
                              </button>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                        {userAdharData?.status === true ? (
                          <div className="input-group input-group-sm mb-3">
                            <label className="commaon_label">Enter OTP</label>
                            <input
                              type="number"
                              className="commaon_input_box border"
                              aria-describedby="basic-addon1"
                              value={AadharOtp}
                              onChange={handleAdharOtpChnage}
                            />

                            {isLoading1 ? (
                              <div
                                className="pl-2 text-center d-flex"
                                style={{
                                  justifyContent: "center",
                                  width: "100%",
                                  marginTop: "10px",
                                }}
                              >
                                <img
                                  src="/images/LandingPage_img/loader1.gif"
                                  style={{ width: "50px", height: "50px" }}
                                  alt="Loading..."
                                />
                              </div>
                            ) : (
                              <div className="pl-2 text-center">
                                <button
                                  onClick={AdharOtp}
                                  className={`profile_wallet bg-dark mt-2 ${
                                    isLoading1 ? "loading" : ""
                                  }`}
                                  disabled={isLoading1}
                                >
                                  Submit OTP
                                </button>
                              </div>
                            )}
                          </div>
                        ) : (
                          " "
                        )}
                      </div>
                    )}
                    {SData.offlineKYC && (
                      <div
                        className={`tab-pane fade ${
                          !SData.onlineKYC && SData.offlineKYC
                            ? "show active"
                            : ""
                        }`}
                        id="game"
                        role="tabpanel"
                        aria-labelledby="game-tab"
                      >
                        <div class="input-group input-group-sm mb-3">
                          <label className="commaon_label">Enter Name</label>
                          <input
                            type="text"
                            class="commaon_input_box border"
                            value={Names}
                            onChange={(e) => setNames(e.target.value)}
                            aria-label="Sizing example input"
                            aria-describedby="inputGroup-sizing-sm"
                          />
                        </div>
                        <div class="input-group input-group-sm mb-3">
                          <label className="commaon_label">
                            Enter Aadhar Number
                          </label>
                          <input
                            type="text"
                            class="commaon_input_box border"
                            value={AadharNum}
                            onChange={handleAdharChnage}
                            aria-label="Sizing example input"
                            aria-describedby="inputGroup-sizing-sm"
                          />
                        </div>
                        <div class="input-group input-group-sm mb-3">
                          <label className="commaon_label">
                            Enter your Email
                          </label>
                          <input
                            type="email"
                            class="commaon_input_box border"
                            value={Email}
                            onChange={handleEmailChange}
                            aria-label="Sizing example input"
                            aria-describedby="inputGroup-sizing-sm"
                          />
                        </div>
                        <div class="input-group input-group-sm mb-3">
                          <label className="commaon_label">Enter DOB</label>
                          <input
                            type="date"
                            class="commaon_input_box border"
                            value={DOB}
                            onChange={(e) => setDob(e.target.value)}
                            aria-label="Sizing example input"
                            aria-describedby="inputGroup-sizing-sm"
                          />
                        </div>
                        <div class="input-group input-group-sm mb-3">
                          <label className="commaon_label">Front Image</label>
                          <input
                            class="commaon_input_box border"
                            id="frontPhoto"
                            name="frontPhoto"
                            type="file"
                            onChange={(e) => setFrontLoaded(e.target.files)}
                            accept="image/*"
                            required
                            aria-label="Sizing example input"
                            aria-describedby="inputGroup-sizing-sm"
                          />
                        </div>

                        <div class="input-group input-group-sm mb-3">
                          <label className="commaon_label">Back Image</label>
                          <input
                            id="backPhoto"
                            name="backPhoto"
                            type="file"
                            accept="image/*"
                            onChange={(e) => setBackLoaded(e.target.files)}
                            class="commaon_input_box border"
                            aria-label="Sizing example input"
                            aria-describedby="inputGroup-sizing-sm"
                            required
                          />
                        </div>

                        <button
                          className="profile_wallet mt-2 mb-2 bg-dark"
                          onClick={handleSubmitdata}
                        >
                          submit
                        </button>
                      </div>
                    )}
                  </div>

                  <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseKyc}>
                      Close
                    </Button>
                  </Modal.Footer>
                </Modal>
              </div>
            </div>
          </div>

          <div className="profile-card-container">
            <div className="profile-header">
              <h2 className="profile-title">Complete Profile</h2>
            </div>

            <div className="info-section">
              {/* Mobile Number Row */}
              <div className="info-row">
                <div className="icon-wrapper bg-phone-gradient">
                  <img src="/images/phone.png" alt="phone" />
                </div>
                <div className="info-text">
                  <span className="label">Mobile Number</span>
                  <span className="value">{profile && profile.Phone}</span>
                </div>
              </div>

              {/* Email Row */}
              <div className="info-row">
                <div className="icon-wrapper bg-email-gradient">
                  <img src="/images/mail.png" alt="email" />
                </div>
                <div className="info-text">
                  <span className="label">Email Address</span>
                  <span className="value">
                    {profile?.Email === null
                      ? "Update Your Email"
                      : profile?.Email}
                  </span>
                </div>
                <button className="edit-btn" onClick={toggleInput}>
                  <img src="/images/pencel.png" alt="edit" />
                </button>
              </div>

              {/* Email Input Field (Conditional) */}
              {inputOpen && (
                <div className="email-input-container">
                  <input
                    aria-invalid={!isValidEmail}
                    type="email"
                    className="custom-email-input"
                    placeholder="Enter your email"
                    value={Email}
                    onChange={handleEmailChange}
                  />
                  <button
                    className="save-email-btn"
                    onClick={() => {
                      toggleInput();
                      if (isValidEmail) {
                        UpdateEmail(Id);
                      } else {
                        Swal.fire({
                          title: "Please enter a valid email",
                          icon: "error",
                          confirmButtonColor: "#3085d6",
                        });
                      }
                    }}
                  >
                    <img src="/images/select-blue-checkIcon1.png" alt="save" />
                  </button>
                </div>
              )}
            </div>

            {/* KYC Status Section */}
            <div className="kyc-section">
              {profile && profile.verified === "verified" ? (
                <div className="kyc-badge success">
                  <img src="/images/LandingPage_img/kyc.gif" alt="verified" />
                  <p>KYC Successfully Verified ✅</p>
                </div>
              ) : (
                <div
                  className={`kyc-badge ${profile?.verified || "unverified"}`}
                  onClick={Kyc}
                >
                  <img src="/images/LandingPage_img/kyc.gif" alt="kyc status" />
                  <p className="mb-0 text-white">
                    {profile && profile.verified === "pending"
                      ? "Verification In Process ⌚"
                      : profile && profile.verified === "reject"
                        ? "KYC Rejected ❌"
                        : "START KYC VERIFICATION"}
                  </p>
                </div>
              )}
            </div>
          </div>
          {/* referal box */}
          {/* {profile && !profile.referral && (
            <div className="referral-card-wrapper" style={styles}>
              <div className="referral-header">
                <h2 className="referral-title">
                  {translations[language].refer}
                </h2>
               
              </div>

              <div className="referral-input-group">
                <div className="input-with-icon">
                  <span className="input-prefix-icon">🎁</span>
                  <input
                    type="text"
                    className="modern-referral-input"
                    value={referral}
                    onChange={(e) => setCode(e.target.value)}
                    placeholder="Enter Refer Code"
                  />
                  <button
                    className={`modern-submit-btn ${
                      !referral?.trim() ? "btn-inactive" : "btn-active"
                    }`}
                    disabled={!referral?.trim()}
                    onClick={update_RefCode}
                  >
                    <img src="/images/select-blue-checkIcon.png" alt="apply" />
                    <span>Apply</span>
                  </button>
                </div>
              </div>
            </div>
          )} */}

          {/* cash won small box */}
          <div className="profile_info_small_box_main_row pt-0" style={styles}>
            <h2 className="profile_headings" style={styles}>
              Other Details
            </h2>

            <div className="row rows">
              <div className="col-6 col-sm-6 pl-0">
                <div className="profile_info_small_box_main profile-bg-1 bg_3 ">
                  <div className="profile_info_small_box_inner ">
                    <img
                      src="/images/icons/prize.png"
                      alt=""
                      className="img-fluid"
                    />
                  </div>
                  <h3>{translations[language].referEarn}</h3>

                  <h4> {profile && profile.referral_earning}</h4>
                </div>
              </div>
              <div className="col-6 col-sm-6">
                <div className="profile_info_small_box_main bg_3">
                  <div className="profile_info_small_box_inner ">
                    <img
                      src="/images/icons/crossed.png"
                      alt=""
                      className="img-fluid"
                    />
                  </div>
                  <h3>{translations[language].game}</h3>

                  <h4> {total && total}</h4>
                </div>
              </div>

              <div className="col-6 col-sm-6 mt-3 pl-0">
                <div className="profile_info_small_box_main bg_3 ">
                  <div className="profile_info_small_box_inner ">
                    <img
                      src="/images/icons/rupee.png"
                      alt=""
                      className="img-fluid"
                    />
                  </div>
                  <h3>{translations[language].Win}</h3>

                  {/* <h4> {profile && profile.Win}</h4> */}
                  <h4> {profile && profile.wonAmount}</h4>
                </div>
              </div>

              <div className="col-6 col-sm-6 mt-3">
                <div className="profile_info_small_box_main bg_3 ">
                  <div className="profile_info_small_box_inner ">
                    <img
                      src="/images/icons/atm.png"
                      alt=""
                      className="img-fluid"
                    />
                  </div>

                  <h3>Total Withdrawal</h3>

                  <h4> {profile && profile.totalWithdrawl}</h4>
                  {/* <h3>{translations[language].referPerson}</h3>

                  <h4> {profile && profile.referral_user?.length}</h4> */}
                </div>
              </div>
            </div>
            <div className="logout_div">
              <Link
                to="/login"
                className="glow-btn w-100 text-center"
                onClick={(e) => logout(e)}
              >
                Log Out
              </Link>
            </div>
          </div>
        </div>
      }

      <div className="rightContainer">
        <Rightcontainer />
      </div>
      {/* <ModalProfile style3={
                profileModalstyle
            } Enter={Enter}/> */}
      <div className={css.kyc_select} id="profileModal">
        <div className={css.overlay} />
        <div
          className={`${css.box}`}
          style={{
            bottom: "0px",
            position: "absolute",
          }}
        >
          <div className={css.bg_white}>
            <div className={`${css.header} ${css.cxy} ${css.flex_column}`}>
              <picture>
                <img
                  height="80px"
                  width="80px"
                  src="/images/avatars/Avatar2.png"
                  alt=""
                />
              </picture>
              <div className={`${css.header_text} mt-2`}>Choose Avatar</div>
            </div>
            <div className="mx-3 pb-3" style={{ paddingTop: "200px" }}>
              <div className="row justify-content-between col-10 mx-auto">
                <img
                  height="50px"
                  width="50px"
                  src="/images/avatars/Avatar1.png"
                  alt=""
                />
                <img
                  height="50px"
                  width="50px"
                  src="/images/avatars/Avatar2.png"
                  alt=""
                />
                <img
                  height="50px"
                  width="50px"
                  src="/images/avatars/Avatar3.png"
                  alt=""
                />
                <img
                  height="50px"
                  width="50px"
                  src="/images/avatars/Avatar4.png"
                  alt=""
                />
              </div>
              <div className="row justify-content-between col-10 mx-auto mt-3">
                <img
                  height="50px"
                  width="50px"
                  src="/images/avatars/Avatar5.png"
                  alt=""
                />
                <img
                  height="50px"
                  width="50px"
                  src="/images/avatars/Avatar6.png"
                  alt=""
                />
                <img
                  height="50px"
                  width="50px"
                  src="/images/avatars/Avatar3.png"
                  alt=""
                />
                <img
                  height="50px"
                  width="50px"
                  src="/images/avatars/Avatar8.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Profile1;
